import axios from 'axios'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import DeliveryPointFactory from '@/services/factories/DeliveryPointFactory'

const DeliveryPointsService = {
  getPoints(deliveryId: number): Promise<DeliveryPoint[]> {
    return axios
      .get(`/admin/deliveries/${deliveryId}/points`)
      .then(response => response.data.points)
  },

  savePoint(
    deliveryId: number,
    deliveryPoint: DeliveryPoint
  ): Promise<DeliveryPoint> {
    const request = deliveryPoint.id
      ? axios.put(`/admin/points/${deliveryPoint.id}`, deliveryPoint)
      : axios.post(`/admin/deliveries/${deliveryId}/points`, deliveryPoint)

    return request.then(response => response.data.deliveryPoint)
  },

  deletePoint(deliveryPointId: number): Promise<any> {
    return axios.delete(`/admin/points/${deliveryPointId}`)
  },

  makeDeliveryPointModel({
    cityId,
    deliveryId,
  }: {
    cityId: number
    deliveryId: number
  }) {
    return DeliveryPointFactory({
      cityId,
      deliveryId,
    })
  },
}

export default DeliveryPointsService
